module.exports = __webpack_public_path__ + "img/Flag_of_Brazil.238fc318.svg";